import { ResponseType  } from "axios";

/*****  API URLs  *****/
const PROD:string = 'https://apiservicios.segurnet.com.do'
export const BASEURL: string = PROD

// const DEV:string = 'https://servicios-api-prueba.segurnet.com.do'
// export const BASEURL: string = DEV

interface IApi {
 name: string;
 url: string;
 method: string;
 headers?: any;
 responseType?: ResponseType;
}
//params: {codCliente: JSON.parse(localStorage.getItem('cliCod') || 'null')},

const Corporatives: IApi[] = [

 //GENERICS
 { name: 'postRefreshToken', url: `${BASEURL}/ObtenerRefreshToken`, method: 'POST' },
 { name: 'updatePassword', url: `${BASEURL}/CambiarClaveUsuario`, method: 'POST' },


 //---------- CORPORATION
 { name: 'getBillingCop', url: `${BASEURL}/GetCuentasxCobrar`, method: 'GET' },
 { name: 'getBillingCxCCop', url: `${BASEURL}/GetRecibosModal`, method: 'GET' },
 { name: 'getBillingPayAgreCop', url: `${BASEURL}/GetAcuerdosPagosModal`, method: 'GET' },
 { name: 'downloadBillingReport', url: `${BASEURL}/api/service/facturas/GetExportExcelFactura`, method: 'POST', responseType: 'blob'},
 { name: 'downloadBillingReportByDate', url: `${BASEURL}/ExportExcelFacturabyFechas`, method: 'POST', responseType: 'blob'},
 { name: 'getPoliciesCop', url: `${BASEURL}/GetPolizasActivas`, method: 'GET' },
 { name: 'getPoliciesCopByCode', url: `${BASEURL}/GetDetallePolizas`, method: 'GET' },
 { name: 'getInactivePoliciesCop', url: `${BASEURL}/GetPolizasCanceladas`, method: 'GET' },
 { name: 'getArchivosFisicobyCodPol', url: `${BASEURL}/GetArchivosFisicobyPoliza`, method: 'GET' },
 { name: 'downloadPoliciesReport', url: `${BASEURL}/api/service/poliza/GetExportExcelPoliza`, method: 'POST', responseType: 'blob'},
 { name: 'downloadPoliciesReportByDate', url: `${BASEURL}/ExportExcelPolizabyFechas`, method: 'POST', responseType: 'blob'},
 { name: 'downloadExcelFlotillasByDate', url: `${BASEURL}​/ExportExcelFlotillabyFechas`, method: 'POST', responseType: 'blob'},
 { name: 'downloadFhysicalFiles', url: `${BASEURL}/DescargarArchivos`, method: 'POST', responseType: 'blob'},
 { name: 'getClaimsCop', url: `${BASEURL}/GetReclamacionbyClientes`, method: 'GET' },
 { name: 'getFleetVehicleCop', url: `${BASEURL}/GetFlotillaVehiculo`, method: 'GET' },
 { name: 'getFleetExcludedVehicleCop', url: `${BASEURL}/GetVehiculosExcluidos`, method: 'GET' },
 { name: 'downloadMarbete', url: `${BASEURL}/GenerarMarbetes`, method: 'POST', responseType: 'blob'},
 { name: 'putFlotillaStatus', url: `${BASEURL}/CambiarEstadoFlotillabyCode`, method: 'PUT' },
 //INDIVIDUALS
 { name: 'switchTenan', url: `${BASEURL}/SwitchingTenancy`, method: 'POST' },
 { name: 'getPolicesInd', url: `${BASEURL}/GetPolizasAutoIndividuales`, method: 'GET' },
 { name: 'getMarbeteDetailsInd', url: `${BASEURL}/GetDetalleMarbeteIndividual`, method: 'GET' },
 { name: 'GeneraPDFMarbeteInv', url: `${BASEURL}/GeneraPDFMarbeteIndividual`, method: 'POST', responseType: 'blob' }
]


const Clients: IApi[] = [
 //----------- CLIENT
 //Polices
 { name: 'getPolices', url: `${BASEURL}/service/policies/get`, method: 'GET' },
 //Products
 { name: 'getProducts', url: `${BASEURL}/service/products/get`, method: 'GET' },
 //Reclamations
 { name: 'getReclamations', url: `${BASEURL}/service/reclamation/get`, method: 'GET' },
 { name: 'getReclamationsByID', url: `${BASEURL}/service/reclamation/save`, method: 'POST' },
 { name: 'sendReclamations', url: `${BASEURL}/service/reclamation/getdetails`, method: 'POST' },
 //User
 { name: 'updateUser', url: `${BASEURL}/service/users/update`, method: 'PUT' },
 //Common
 { name: 'sendEmail', url: `${BASEURL}/service/sendmail`, method: 'POST' },
]

export const apis: IApi[] = [
 ...Corporatives,
 ...Clients
]


